import React, { useContext, useState } from "react";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import "./Breadcrumbs.css";
import ExitWithoutSavingModal from "../programDetailModals/ExitWithoutSavingModal";
import { Context } from "../../context/Context";
import ExerciseBuilderModal from "../programDetailModals/ExerciseBuilderModal";

function Breadcrumbs(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [dashboardEditWithoutSavingModal, setDashboardEditWithoutSavingModal] =
    useState(false);
  const [programsEditWithoutSavingModal, setProgramsEditWithoutSavingModal] =
    useState(false);
  const [
    programNameEditWithoutSavingModal,
    setProgramNameEditWithoutSavingModal,
  ] = useState(false);
  const [
    programName2EditWithoutSavingModal,
    setProgramName2EditWithoutSavingModal,
  ] = useState(false);

  var isTemplate =
    localStorage.getItem("prev_link") === "newtemplate"
      ? true
      : localStorage.getItem("programDataEdit") &&
        JSON.parse(localStorage.getItem("programDataEdit")).is_template ===
          true &&
        true;

  var programName = props.programName
    ? props.programName
    : localStorage.getItem("prog_edit_name")
    ? localStorage.getItem("prog_edit_name")
    : "New Protocol"

  var programId = localStorage.getItem("programIdEdit")
    ? localStorage.getItem("programIdEdit")
    : id;

  const isTherapist =
    localStorage.getItem("userData") &&
    JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).user_type === 2
        ? true
        : false
      : false;
  const location = useLocation();

  const fromExerBuilder = (param) => {
    if (param === "edit") {
      navigate("/protocols/" + programId + "/edit");
      localStorage.setItem("fromExerBuilder", true);
    } else if (param === "new") {
      navigate("/newtemplate");
      localStorage.setItem("fromExerBuilder", true);
    }
  };

  // ______________________ ProgramDetails NAVIGATION FUNCTIONS ____________________________________

  const handleCleanNewProgramLocalData = () => {
    console.log("CLEAN NEW PROG DATA");
    localStorage.removeItem("allNewProgramData");
    localStorage.removeItem("preserveSession");
    localStorage.removeItem("programWeeks");
    localStorage.removeItem("dayInx");
    localStorage.removeItem("deleted_tasks");
    localStorage.removeItem("newprogram_dayDets");
    localStorage.removeItem("newprogram_progDets");
    localStorage.removeItem("start_date");
    localStorage.removeItem("taskInx");
    localStorage.removeItem("programDataEdit");
    localStorage.removeItem("prog_edit_name");
    localStorage.removeItem("new_tasks");
    localStorage.removeItem("new_program");
    localStorage.removeItem("newPrograms");
    localStorage.removeItem("fromExerBuilder");
    localStorage.removeItem("is_assigned");
  };

  const handleCleanEditProgramLocalData = () => {
    console.log("CLEAN EDIT PROG DATA");
    localStorage.removeItem("editProgramData");
    localStorage.removeItem("editProgram_progDets");
    localStorage.removeItem("editProgram_dayDets");
    localStorage.removeItem("editPreserveSessionID");
    localStorage.removeItem("disableUnLoad");
    if (localStorage.getItem("editProgram_newtasks")) {
      localStorage.setItem(
        "new_tasks",
        localStorage.getItem("editProgram_newtasks")
      );
    }
  };

  // _____________________________ DASHBOARD CLICK FUNCTIONS START __________________________________________

  const handleDashboardModalClick = () => {
    if (
      localStorage.getItem("disableUnLoad") ||
      localStorage.getItem("ExerBuilderEdited")
    ) {
      setDashboardEditWithoutSavingModal(true);
    } else {
      navigate("/dashboard", { replace: true });
    }
  };

  const handleDashboardModalClose = () => {
    setDashboardEditWithoutSavingModal(false);
  };

  const handleDashboardYes = () => {
    if (location.pathname?.includes("/protocols")) {
      handleCleanEditProgramLocalData();
    } else if (location.pathname?.includes("/newtemplate")) {
      handleCleanNewProgramLocalData();
    } else if (localStorage.getItem("taskBuilderType") === "edit") {
      handleCleanEditProgramLocalData();
    } else if (localStorage.getItem("taskBuilderType") === "new") {
      handleCleanNewProgramLocalData();
    }
    navigate("/dashboard", { replace: true });
  };

  const handleDashboardNo = () => {
    navigate("/dashboard", { replace: true });
  };

  // ______________________ PROGRAMS CLICK FUNCTIONS _______________________________________

  const handleProgramsModalClick = () => {
    if (
      localStorage.getItem("disableUnLoad") ||
      localStorage.getItem("ExerBuilderEdited")
    ) {
      setProgramsEditWithoutSavingModal(true);
    } else {
      navigate("/programs", { replace: true });
    }
  };

  const handleProgramsModalClose = () => {
    setProgramsEditWithoutSavingModal(false);
  };

  const handleProgramsYes = () => {
    if (location.pathname?.includes("/protocols")) {
      handleCleanEditProgramLocalData();
    } else if (location.pathname?.includes("/newtemplate")) {
      handleCleanNewProgramLocalData();
    } else if (localStorage.getItem("taskBuilderType") === "edit") {
      handleCleanEditProgramLocalData();
    } else if (localStorage.getItem("taskBuilderType") === "new") {
      handleCleanNewProgramLocalData();
    }
    navigate("/programs", { replace: true });
  };

  const handleProgramsNo = () => {
    navigate("/programs", { replace: true });
  };

  // __________________________ PROG NAME CLICK FUNCTIONS __________________________________

  const handleProgramNameModalClick = () => {
    console.log("EDIT PROG NAVIGATE");
    if (localStorage.getItem("ExerBuilderEdited")) {
      setProgramNameEditWithoutSavingModal(true);
    } else {
      fromExerBuilder("edit");
      localStorage.removeItem("ExerBuilderEdited");
    }
  };

  const handleProgramNameModalClose = () => {
    setProgramNameEditWithoutSavingModal(false);
  };

  const handleProgramNameYes = () => {
    fromExerBuilder("edit");
    localStorage.removeItem("ExerBuilderEdited");
  };

  const { setSaveExerciseBuilder } = useContext(Context);

  const handleProgramNameNo = () => {
    setSaveExerciseBuilder(true);
  };

  // __________________________ PROG NAME CLICK FUNCTIONS __________________________________

  const handleProgramName2ModalClick = () => {
    console.log("NEW PROG NAVIGATE");
    if (localStorage.getItem("ExerBuilderEdited")) {
      setProgramName2EditWithoutSavingModal(true);
    } else {
      fromExerBuilder("new");
      localStorage.removeItem("ExerBuilderEdited");
    }
  };

  const handleProgramName2ModalClose = () => {
    setProgramName2EditWithoutSavingModal(false);
  };

  const handleProgramName2Yes = () => {
    fromExerBuilder("new");
    localStorage.removeItem("ExerBuilderEdited");
  };

  return (
    <div className="breadc_holder">
      <nav>
        {isTherapist && (
          <>
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                handleDashboardModalClick();
              }}
              className={
                location.pathname.startsWith === "/dashboard"
                  ? "breadcrumb-active"
                  : "breadcrumb-not-active"
              }
            >
              Dashboard
            </Link>
            <span className="breadcrumb-arrow">&gt;</span>
          </>
        )}
        {location.pathname === "/newworkout" ||
        location.pathname === "/newworkout/" + props.workoutId ? (
          <Link
            to="/workouts"
            className={
              location.pathname.startsWith("/workouts")
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            PT Session
          </Link>
        ) : location.pathname === "/add-new-member" ||
          location.pathname.startsWith("/edit-member") ||
          location.pathname === "/add-new-therapist" ? (
          <Link
            to="/settings"
            className={
              location.pathname.startsWith("/settings")
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            Settings
          </Link>
        ) : location.pathname === "/add-new-client" ||
          location.pathname.startsWith("/edit-client") ? (
          <Link
            to="/clients"
            className={
              location.pathname.startsWith("/clients")
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            Clients
          </Link>
        ) : location.pathname ===
          "/add-care-team/" + props.id + "/" + props.program_id ? (
          <Link
            to={"/patient-protocols/" + props.id + "/" + props.program_id}
            className={
              location.pathname.startsWith("/patient-protocols")
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            Patient Details
          </Link>
        ) : location.pathname === "/newtemplate" ||
          isTemplate === "newtemplate" ||
          isTemplate === true ? (
          <Link
            to="/programs/tab2"
            className={
              location.pathname.startsWith("/programs")
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            Protocols
          </Link>
        ) : (
          <Link
            to={"#"}
            onClick={(e) => {
              e.preventDefault();
              handleProgramsModalClick();
            }}
            className={
              location.pathname.startsWith("/programs")
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            Recovery Plan
          </Link>
        )}
        
        <span className="breadcrumb-arrow">&gt;</span>
        {location.pathname === "/newtemplate" ? (
          <Link
            to="/newtemplate"
            className={
              location.pathname === "/newtemplate"
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            {programName}
          </Link>
        ) : isTemplate === true && programId === undefined ? (
          <Link
            to={"/newtemplate"}
            className={
              location.pathname === "/newtemplate"
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            {programName}
          </Link>
        ) : location.pathname === "/newworkout" ? (
          <Link
            to="/newworkout"
            className={
              location.pathname === "/newworkout"
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            New PT Session
          </Link>
        ) : location.pathname === "/add-new-therapist" ? (
          <Link
            to="/add-new-therapist"
            className={
              location.pathname === "/add-new-therapist"
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            Add New Therapist
          </Link>
        ) : location.pathname === "/newworkout/" + props.workoutId ? (
          <Link
            to={"/newworkout/" + props.workoutId}
            className={
              location.pathname.startsWith("/newworkout/" + props.workoutId)
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            {props.workoutName ? props.workoutName : "Edit PT Session"}
          </Link>
        ) : location.pathname === "/add-new-member" ? (
          <Link
            to="/add-new-member"
            className={
              location.pathname.startsWith("/add-new-member")
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            Members
          </Link>
        ) : location.pathname.startsWith("/edit-member") ? (
          <Link to={location.pathname} className="breadcrumb-active">
            Edit Member
          </Link>
        ) : location.pathname === "/add-new-client" ? (
          <Link
            to="/add-new-client"
            className={
              location.pathname.startsWith("/add-new-client")
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            Add New Client
          </Link>
        ) : location.pathname.startsWith("/edit-client") ? (
          <Link to={location.pathname} className="breadcrumb-active">
            Edit Client
          </Link>
        ) : location.pathname ===
          "/add-care-team/" + props.id + "/" + props.program_id ? (
          <Link
            to={"/add-care-team/" + props.id + "/" + props.program_id}
            className={
              location.pathname.startsWith("/add-care-team")
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            Add Care Team
          </Link>
        ) : location.pathname === "/newtemplate" ? (
          <Link
            to="/newtemplate"
            className={
              location.pathname === "/newtemplate"
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            {programName.length === 0 ? "New Protocol" : programName}
          </Link>
        ) : location.pathname === "/protocols/" + programId + "/edit" ? (
          <Link
            to={"/protocols/" + programId + "/edit"}
            className={
              location.pathname === "/protocols/" + programId + "/edit"
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            {programName}
          </Link>
        ) : location.pathname === "/protocols/" + programId ? (
          <Link
            to={"/protocols/" + programId}
            className={
              location.pathname.startsWith("/protocols") &&
              location.pathname === "/protocols/" + programId
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            {programName}
          </Link>
        ) : location.pathname.startsWith("/tasks/") &&
          programId &&
          isTemplate === false ? (
          <div
            style={{ display: "inline-block", cursor: "pointer" }}
            onClick={(e) => {
              e.preventDefault();
              handleProgramNameModalClick();
            }}
            // onClick={() => fromExerBuilder("edit")}
            /* to={"/protocols/" + programId + "/edit"} */
            className={
              location.pathname === "/protocols/" + programId
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            {programName}
            {localStorage.setItem("taskBuilderType", "edit")}
          </div>
        ) : isTemplate === true && programId !== undefined ? (
          <Link
            to={"/protocols/" + programId + "/edit"}
            className={
              location.pathname === "/newtemplate"
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            {programName}
          </Link>
        ) : (
          <div
            style={{ display: "inline-block", cursor: "pointer" }}
            onClick={(e) => {
              e.preventDefault();
              handleProgramName2ModalClick();
            }}
            /* to={"/protocols/" + programId + "/edit"} */
            className={
              location.pathname === "/newtemplate"
                ? "breadcrumb-active"
                : "breadcrumb-not-active"
            }
          >
            {programName}
            {localStorage.setItem("taskBuilderType", "new")}
          </div>
        )}

        {location.pathname ===
          "/tasks/newtask/" + props.dayInx + "/" + props.taskInx ||
        location.pathname.startsWith("/tasks/" + props.task_id) ? (
          <span>
            <span className="breadcrumb-arrow">&gt;</span>
            <Link
              to={"/tasks/newtask/" + props.dayInx + "/" + props.taskInx}
              className={
                location.pathname.startsWith(
                  "/tasks/newtask/" + props.dayInx + "/" + props.taskInx
                )
                  ? "breadcrumb-active"
                  : location.pathname.startsWith("/tasks/" + props.task_id)
                  ? "breadcrumb-active"
                  : "breadcrumb-not-active"
              }
            >
              {props.workoutName
                ? props.workoutName
                : localStorage.getItem("exerBuilderTaskType")
                ? "New Range of Motion Test"
                : "New PT Session"}
            </Link>
          </span>
        ) : (
          ""
        )}
      </nav>

      {/* -------------------- DASHBOARD MODAL ---------------------- */}
      <ExitWithoutSavingModal
        title={"Do you want to exit without saving?"}
        openModal={dashboardEditWithoutSavingModal}
        handleModalClose={handleDashboardModalClose}
        handleYes={handleDashboardYes}
        handleNo={handleDashboardNo}
      />
      {/* ------------------- PROGRAMS MODAL -------------------- */}
      <ExitWithoutSavingModal
        title={"Do you want to exit without saving?"}
        openModal={programsEditWithoutSavingModal}
        handleModalClose={handleProgramsModalClose}
        handleYes={handleProgramsYes}
        handleNo={handleProgramsNo}
      />
      {/* ------------------- EDIT PROGRAM NAME MODAL -------------------- */}
      {/* <ExitWithoutSavingExerciseModal
        title={"Do you want to exit without saving exercise?"}
        openModal={programNameEditWithoutSavingModal}
        handleModalClose={handleProgramNameModalClose}
        handleYes={handleProgramNameYes}
      />
       */}
      <ExerciseBuilderModal
        title={"Do you want to exit without saving exercise?"}
        openModal={programNameEditWithoutSavingModal}
        handleModalClose={handleProgramNameModalClose}
        handleYes={handleProgramNameYes}
        handleNo={handleProgramNameNo}
      />
      {/* ------------------- NEW PROGRAM NAME MODAL -------------------- */}
      <ExerciseBuilderModal
        title={"Do you want to exit without saving exercise?"}
        openModal={programName2EditWithoutSavingModal}
        handleModalClose={handleProgramName2ModalClose}
        handleYes={handleProgramName2Yes}
        handleNo={handleProgramNameNo}
      />
      {/* ----------------------------------------------------- */}
    </div>
  );
}

export default Breadcrumbs;
